export function simplifyPaginatedResult(data) {
    var _a, _b;
    let result = { totalCount: 0, nodes: [], hasNextPage: false };
    if (!(data === null || data === void 0 ? void 0 : data.pages))
        return result;
    data.pages.forEach(page => {
        if (page === null || page === void 0 ? void 0 : page.edges) {
            page.edges.forEach(edge => {
                if (edge === null || edge === void 0 ? void 0 : edge.node)
                    result.nodes.push(edge.node);
            });
        }
        else if (page === null || page === void 0 ? void 0 : page.nodes) {
            page.nodes.forEach(node => {
                if (node)
                    result.nodes.push(node);
            });
        }
    });
    const lastPage = data.pages[data.pages.length - 1];
    result = {
        ...result,
        ...{
            totalCount: lastPage.totalCount,
            hasNextPage: ((_a = lastPage === null || lastPage === void 0 ? void 0 : lastPage.pageInfo) === null || _a === void 0 ? void 0 : _a.hasNextPage) || false,
            endCursor: (_b = lastPage === null || lastPage === void 0 ? void 0 : lastPage.pageInfo) === null || _b === void 0 ? void 0 : _b.endCursor,
        },
    };
    return result;
}
//# sourceMappingURL=query.js.map